import { use } from "react";
import { WithdrawWizardContext } from "../WithdrawWizardContext";

export const useWithdrawWizard = () => {
  const ctx = use(WithdrawWizardContext);

  if (!ctx) {
    throw new Error("useWithdrawWizard must be used within WithdrawWizard");
  }

  return ctx;
};
